/* SVELIA — finitions premium : menu déroulant « Le Legging », format des prix Pumper */
(function () {
  if (window.__svPremium) return; window.__svPremium = true;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Menu déroulant : ouvert au survol ou au focus du lien produit
    var mega = document.getElementById('sv-mega');
    var trigger = mega && document.querySelector('.header__inline-menu a[href*="/products/"]');
    if (mega && trigger && matchMedia('(min-width: 990px)').matches) {
      var t;
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', 'sv-mega');
      var open = function () { clearTimeout(t); mega.hidden = false; mega.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
      var close = function (now) {
        clearTimeout(t);
        t = setTimeout(function () { mega.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }, now ? 0 : 180);
      };
      [trigger, mega].forEach(function (el) {
        el.addEventListener('mouseenter', open);
        el.addEventListener('mouseleave', function () { close(); });
      });
      trigger.addEventListener('focus', open);
      mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) close(true); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mega.classList.contains('is-open')) { close(true); trigger.focus(); } });
    }

    // Icône panier : petite pulsation quand le panier change (ajout, retrait)
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var pulse = function () {
        bubble.classList.remove('sv-pulse'); void bubble.offsetWidth; bubble.classList.add('sv-pulse');
      };
      bubble.addEventListener('animationend', function () { bubble.classList.remove('sv-pulse'); });
      new MutationObserver(function (m) {
        if (m.some(function (r) { return r.type === 'childList'; })) pulse();
      }).observe(bubble, { childList: true, subtree: true });
    }

    // Widget Pumper : prix au format français (49,90 €) et coquille « La Collections »
    var apps = document.querySelector('.sv-apps');
    if (!apps) return;
    var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    var fix = function () {
      var w = document.createTreeWalker(apps, NodeFilter.SHOW_TEXT), n, v, m;
      while ((n = w.nextNode())) {
        v = n.nodeValue;
        if (fr && (m = v.match(/^(\s*)€\s?([\d\s.,]+)(\s*)$/))) n.nodeValue = m[1] + m[2].trim() + ' €' + m[3];
        else if (v.trim() === 'La Collections') n.nodeValue = v.replace('La Collections', 'La Collection');
      }
    };
    fix();
    var busy = false;
    new MutationObserver(function () {
      if (busy) return; busy = true;
      requestAnimationFrame(function () { fix(); busy = false; });
    }).observe(apps, { subtree: true, childList: true, characterData: true });
  });
})();
